import styled from 'styled-components';

export const StyledAnchor = styled.a`
    color: ${props => props.theme.color.secondary};
    font-size: 1.2rem;
    cursor: pointer;
}
`;